import Api from './api';

export const createManualInvoice = (data) => {
    return Api.post('/admin/invoices', data);
};

export const updateManualInvoice = (invoiceId, data) => {
    return Api.put(`/admin/invoices/${invoiceId}`, data);
};

export const markInvoiceAsPaid = (invoiceId, datePaid = null) => {
    return Api.put(`/admin/invoices/${invoiceId}/mark-paid`, { datePaid });
};

export const cancelInvoice = (invoiceId) => {
    return Api.delete(`/admin/invoices/${invoiceId}`);
};

export const getPaymentMethods = () => {
    return Api.get('/admin/invoices/payment-methods');
};
